var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"render"},[_c('div',{staticClass:"top"},[_c('h1',[_vm._v("Помощь")])]),_c('div',{staticClass:"content_table"})])
}]

export { render, staticRenderFns }